var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, Children, isValidElement, } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input, Popover } from 'antd';
import { ExportOutlined, FormOutlined, UpOutlined } from '@ant-design/icons';
import CardSkeleton from './card';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import './style.css';
var hasActionChildren = function (children) {
    return Children.toArray(children).some(function (child) { return isValidElement(child); });
};
var HomeCard = function (props) {
    var navigate = useNavigate();
    var _a = useState(false), expanded = _a[0], setExpanded = _a[1];
    var _b = useState(false), noteOpen = _b[0], setNoteOpen = _b[1];
    var _c = useState(''), noteDraft = _c[0], setNoteDraft = _c[1];
    var hasActions = hasActionChildren(props.children);
    var appointmentId = props.appointment.getId();
    var _d = services.appointmentService.useSaveAppointmentNote(), saveNote = _d.mutate, isSavingNote = _d.isLoading;
    var toggle = function () {
        if (hasActions) {
            setExpanded(function (value) { return !value; });
        }
    };
    var openVisit = function (event) {
        event.stopPropagation();
        navigate("/appointments/".concat(appointmentId));
    };
    var openNote = function (event) {
        event.stopPropagation();
        setNoteDraft(props.appointment.getNote() || '');
        setNoteOpen(true);
    };
    var submitNote = function () {
        props.appointment.setNote(noteDraft);
        saveNote({ appointment: props.appointment }, {
            onSuccess: function () { return setNoteOpen(false); },
        });
    };
    var notePanel = (_jsxs("div", { className: "stitch-appt-note", onClick: function (e) { return e.stopPropagation(); }, children: [_jsx(Input.TextArea, { value: noteDraft, onChange: function (e) { return setNoteDraft(e.target.value); }, rows: 3, placeholder: props.translate('notePlaceholder'), autoFocus: true }), _jsxs("div", { className: "stitch-appt-note__actions", children: [_jsx(Button, { size: "small", onClick: function () { return setNoteOpen(false); }, children: props.translate('common:buttons.cancel') }), _jsx(Button, { size: "small", type: "primary", loading: isSavingNote, onClick: submitNote, children: props.translate('saveNote') })] })] }));
    return (_jsxs("div", { className: "stitch-appt-shell".concat(expanded ? ' is-open' : '').concat(hasActions ? ' is-interactive' : ''), children: [_jsx("div", { className: "stitch-appt-shell__header", onClick: toggle, onKeyDown: function (event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        toggle();
                    }
                }, role: hasActions ? 'button' : undefined, tabIndex: hasActions ? 0 : undefined, children: _jsx(CardSkeleton, __assign({}, props, { expanded: expanded })) }), expanded && hasActions ? (_jsxs("div", { className: "stitch-appt-shell__body", onClick: function (e) { return e.stopPropagation(); }, children: [_jsxs("div", { className: "stitch-appt-shell__actions", children: [_jsx("div", { className: "stitch-appt-shell__actions-label", children: props.translate('updateStatus') }), _jsx("div", { className: "stitch-appt-shell__actions-grid", children: props.children })] }), _jsxs("div", { className: "stitch-appt-shell__links", children: [_jsxs("button", { type: "button", className: "stitch-appt-shell__open", onClick: openVisit, children: [_jsx(ExportOutlined, {}), _jsx("span", { children: props.translate('openFullVisit') })] }), _jsxs("div", { className: "stitch-appt-shell__link-tools", children: [_jsx(Popover, { content: notePanel, title: props.translate('addNote'), trigger: "click", open: noteOpen, onOpenChange: setNoteOpen, placement: "topRight", children: _jsx("button", { type: "button", className: "stitch-appt-shell__icon-btn", onClick: openNote, "aria-label": props.translate('addNote'), title: props.translate('addNote'), children: _jsx(FormOutlined, {}) }) }), _jsx("button", { type: "button", className: "stitch-appt-shell__icon-btn", onClick: function () { return setExpanded(false); }, "aria-label": props.translate('collapseCard'), title: props.translate('collapseCard'), children: _jsx(UpOutlined, {}) })] })] })] })) : null] }));
};
export default localeTranslator(HomeCard, 'cardSkeleton');
